module.exports = __webpack_public_path__ + "static/media/girl-14.69ee5f71.svg";